export const technologyCatalog = {
  // ======================
  // Languages
  // ======================
  python: {
    icon: 'akar-icons:python-fill',
    name: 'Python',
    domains: ['backend', 'machineLearning', 'aiAgents'],
  },
  django: {
    icon: 'akar-icons:django-fill',
    name: 'Django',
    domains: ['backend', 'aiAgents'],
  },
  reactNative: {
    icon: 'simple-icons:react',
    name: 'React Native',
    domains: ['mobile'],
  },
  flutter: {
    icon: 'simple-icons:flutter',
    name: 'Flutter',
    domains: ['mobile'],
  },
  swift: {
    icon: 'simple-icons:swift',
    name: 'Swift',
    domains: ['mobile'],
  },
  android: {
    icon: 'simple-icons:android',
    name: 'Android',
    domains: ['mobile'],
  },
  ios: {
    icon: 'simple-icons:apple',
    name: 'iOS',
    domains: ['mobile'],
  },
  react: {
    icon: 'akar-icons:react-fill',
    name: 'React',
    domains: ['frontend'],
  },
  angular: {
    icon: 'akar-icons:angular-fill',
    name: 'Angular',
    domains: ['frontend'],
  },
  vue: {
    icon: 'akar-icons:vue-fill',
    name: 'Vue',
    domains: ['frontend'],
  },
  typescript: {
    icon: 'akar-icons:typescript-fill',
    name: 'TypeScript',
    domains: ['frontend', 'backend', 'mobile'],
  },
  javascript: {
    icon: 'akar-icons:javascript-fill',
    name: 'JavaScript',
    domains: ['frontend', 'backend'],
  },
  ruby: {
    icon: 'simple-icons:ruby',
    name: 'Ruby',
    domains: ['backend'],
  },
  rails: {
    icon: 'devicon-plain:rails',
    name: 'Ruby on Rails',
    domains: ['backend'],
  },
  postgresql: {
    icon: 'akar-icons:postgresql-fill',
    name: 'PostgreSQL',
    domains: ['backend', 'integrations'],
  },
  dart: {
    icon: 'simple-icons:dart',
    name: 'Dart',
    domains: ['mobile'],
  },
  // ======================
  // Frontend – main frameworks
  // ======================
  docker: {
    icon: 'fa6-brands:docker',
    name: 'Docker',
    domains: ['devops'],
  },
  kubernetes: {
    icon: 'simple-icons:kubernetes',
    name: 'Kubernetes',
    domains: ['devops'],
  },
  azure: {
    icon: 'simple-icons:microsoftazure',
    name: 'Azure',
    domains: ['devops'],
  },
  aws: {
    icon: 'mdi:aws',
    name: 'AWS',
    domains: ['devops'],
  },
  svelte: {
    icon: 'simple-icons:svelte',
    name: 'Svelte',
    domains: ['frontend'],
  },
  solidjs: {
    icon: 'simple-icons:solid',
    name: 'SolidJS',
    domains: ['frontend'],
  },
  nextjs: {
    icon: 'akar-icons:nextjs-fill',
    name: 'Nextjs',
    domains: ['frontend'],
  },
  // ======================
  // Frontend – other
  // ======================
  gatsby: {
    icon: 'simple-icons:gatsby',
    name: 'Gatsby',
    domains: ['frontend', 'integrations'],
  },
  electron: {
    icon: 'simple-icons:electron',
    name: 'Electron',
    domains: ['frontend'],
  },
  mui: {
    icon: 'simple-icons:mui',
    name: 'MUI',
    domains: ['frontend'],
  },
  html: {
    icon: 'simple-icons:html5',
    name: 'HTML',
    domains: ['frontend'],
  },
  rwd: {
    icon: 'mdi:responsive',
    name: 'RWD',
    domains: ['frontend'],
  },
  webpack: {
    icon: 'simple-icons:webpack',
    name: 'Webpack',
    domains: ['frontend', 'integrations'],
  },
  highcharts: {
    icon: 'material-symbols:dashboard-2-gear-rounded',
    name: 'Highcharts',
    domains: ['frontend', 'integrations'],
  },
  unbounce: {
    icon: 'material-symbols:dashboard-2-gear-rounded',
    name: 'Unbounce',
    domains: ['frontend'],
  },

  // ======================
  // Backend – frameworks & tools
  // ======================
  node: {
    icon: 'devicon-plain:nodejs-wordmark',
    name: 'Node.js',
    domains: ['backend', 'integrations', 'mobile', 'devops'],
  },
  flask: {
    icon: 'simple-icons:flask',
    name: 'Flask',
    domains: ['backend', 'aiAgents'],
  },
  mysql: {
    icon: 'simple-icons:mysql',
    name: 'MySQL',
    domains: ['backend'],
  },
  graphql: {
    icon: 'simple-icons:graphql',
    name: 'GraphQL',
    domains: ['backend', 'aiAgents'],
  },
  restApi: {
    icon: 'mdi:api',
    name: 'REST API',
    domains: ['backend', 'integrations', 'aiAgents'],
  },
  elastic: {
    icon: 'simple-icons:elasticsearch',
    name: 'Elastic',
    domains: ['backend'],
  },
  sentry: {
    icon: 'simple-icons:sentry',
    name: 'Sentry',
    domains: ['backend', 'integrations'],
  },
  supabase: {
    icon: 'simple-icons:supabase',
    name: 'Supabase',
    domains: ['backend', 'devops'],
  },
  firebase: {
    icon: 'mdi:firebase',
    name: 'Firebase',
    domains: ['backend', 'mobile', 'integrations', 'aiAgents', 'devops'],
  },
  titan: {
    icon: 'mdi:alpha-t-box-outline',
    name: 'Titan',
    domains: ['frontend', 'backend', 'integrations'],
  },
  voip: {
    icon: 'simple-icons:voipdotms',
    name: 'VOIP',
    domains: ['integrations', 'backend'],
  },

  // ======================
  // Mobile
  // ======================
  ionic: {
    icon: 'simple-icons:ionic',
    name: 'Ionic',
    domains: ['mobile'],
  },
  // ======================
  // Integrations & Payments
  // ======================
  stripe: {
    icon: 'simple-icons:stripe',
    name: 'Stripe',
    domains: ['integrations'],
  },
  recurly: {
    icon: 'material-symbols:dashboard-2-gear-rounded',
    name: 'Recurly',
    domains: ['integrations'],
  },
  bitgo: {
    icon: 'material-symbols:dashboard-2-gear-rounded',
    name: 'BitGo',
    domains: ['integrations'],
  },
  web3: {
    icon: 'simple-icons:web3dotjs',
    name: 'Web3',
    domains: ['mobile', 'integrations'],
  },
  ethersjs: {
    icon: 'simple-icons:ethers',
    name: 'Ethers.js',
    domains: ['aiAgents', 'integrations'],
  },
  api: {
    icon: 'mdi:api',
    name: 'API',
    domains: ['aiAgents', 'integrations'],
  },

  // ======================
  // Machine Learning / AI
  // ======================
  ai: {
    icon: 'ri:ai',
    name: 'AI',
    domains: ['aiAgents', 'machineLearning'],
  },
  pandas: {
    icon: 'simple-icons:pandas',
    name: 'Pandas',
    domains: ['machineLearning'],
  },
  pytorch: {
    icon: 'simple-icons:pytorch',
    name: 'PyTorch',
    domains: ['machineLearning'],
  },
  tensorflow: {
    icon: 'simple-icons:tensorflow',
    name: 'TensorFlow',
    domains: ['machineLearning'],
  },
  keras: {
    icon: 'simple-icons:keras',
    name: 'Keras',
    domains: ['machineLearning'],
  },
  go: {
    icon: 'simple-icons:go',
    name: 'Go',
    domains: ['backend', 'devops'],
  },
  scikitLearn: {
    icon: 'simple-icons:scikitlearn',
    name: 'Scikit-learn',
    domains: ['machineLearning'],
  },
  opencv: {
    icon: 'simple-icons:opencv',
    name: 'OpenCV',
    domains: ['machineLearning'],
  },
  selenium: {
    icon: 'simple-icons:selenium',
    name: 'Selenium',
    domains: ['machineLearning'],
  },
  jinja: {
    icon: 'material-icon-theme:jinja',
    name: 'Jinja',
    domains: ['backend'],
  },
  cypress: {
    icon: 'simple-icons:cypress',
    name: 'Cypress',
    domains: ['machineLearning'],
  },
  redis: {
    icon: 'devicon-plain:redis',
    name: 'Redis',
    domains: ['backend', 'integrations'],
  },
  vite: {
    icon: 'simple-icons:vite',
    name: 'Vite',
    domains: ['frontend'],
  },
  // ======================
  // DevOps
  // ======================
  vercel: {
    icon: 'akar-icons:vercel-fill',
    name: 'Vercel',
    domains: ['devops'],
  },
  terraform: {
    icon: 'simple-icons:terraform',
    name: 'Terraform',
    domains: ['devops'],
  },
  ansible: {
    icon: 'simple-icons:ansible',
    name: 'Ansible',
    domains: ['devops'],
  },
  jenkins: {
    icon: 'simple-icons:jenkins',
    name: 'Jenkins',
    domains: ['machineLearning', 'devops'],
  },
  circleci: {
    icon: 'simple-icons:circleci',
    name: 'CircleCI',
    domains: ['devops'],
  },
  heroku: {
    icon: 'devicon-plain:heroku',
    name: 'Heroku',
    domains: ['devops'],
  },
  fastapi: {
    icon: 'simple-icons:fastapi',
    name: 'FastAPI',
    domains: ['backend', 'aiAgents'],
  },
  celery: {
    icon: 'simple-icons:celery',
    name: 'Celery',
    domains: ['backend'],
  },
  swagger: {
    icon: 'simple-icons:swagger',
    name: 'Swagger',
    domains: ['backend', 'integrations'],
  },
  mongodb: {
    icon: 'simple-icons:mongodb',
    name: 'MongoDB',
    domains: ['backend'],
  },
  sqlite: {
    icon: 'simple-icons:sqlite',
    name: 'SQLite',
    domains: ['backend'],
  },
  prisma: {
    icon: 'simple-icons:prisma',
    name: 'Prisma',
    domains: ['backend'],
  },
  githubActions: {
    icon: 'simple-icons:github',
    name: 'GitHub',
    domains: ['devops'],
  },
  nginx: {
    icon: 'simple-icons:nginx',
    name: 'Nginx',
    domains: ['devops', 'backend'],
  },
  wordpress: {
    icon: 'simple-icons:wordpress',
    name: 'WordPress',
    domains: ['frontend', 'integrations'],
  },
} satisfies Record<string, TechnologyDefinition>;

export type TechnologyDefinition = {
  icon: string;
  name: string;
  domains: TechnologyDomain[];
};
export type Technologies = keyof typeof technologyCatalog;
export type TechnologyDomain =
  | 'frontend'
  | 'backend'
  | 'mobile'
  | 'integrations'
  | 'machineLearning'
  | 'aiAgents'
  | 'devops';
